<template>
  <v-layout row justify-center>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      justify-end
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn
            icon
            dark
            @click="(dialog = false), (step = 1), (processing = false)"
          >
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Antecipação Manual</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat disabled style="color: #fff !important"
              >Valor a ser antecipado
              {{ $n(selectedAnticipationsAmount, "currency") }}</v-btn
            >
          </v-toolbar-items>
          <v-toolbar-items>
            <v-btn
              dark
              flat
              @click="sendAnticipations"
              :disabled="status === 'processing'"
            >
              <span v-if="status === 'wait'">Avançar</span>
              <v-icon v-if="status === 'wait'">arrow_forward</v-icon>
              <v-progress-circular
                v-if="status === 'processing'"
                indeterminate
              ></v-progress-circular>
              <span v-if="status === 'finished'">Sair</span>
              <v-icon v-if="status === 'finished'">arrow_forward</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider></v-divider>
        <v-list three-line subheader>
          <v-stepper v-model="step" class="elevation-0">
            <v-stepper-header>
              <v-stepper-step :complete="step > 1" step="1">
                <small>Selecione os pagamentos desejados</small>
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step :complete="step > 2" step="2">
                <small>Processando o pedido</small>
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step step="3">
                <small>Concluido</small>
              </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">
                <anticipations-available />
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-layout>
                  <v-flex xs12 sm6 offset-sm3 class="text-md-center">
                    <img src="@/assets/cloud_load.gif" height="200px" />

                    <p>
                      <span
                        class="subheading text-uppercase font-weight-regular"
                        style="color: #01579b"
                        >Processando seu pedido</span
                      >
                    </p>
                  </v-flex>
                </v-layout>
              </v-stepper-content>

              <v-stepper-content step="3">
                <v-layout>
                  <v-flex xs12 sm6 offset-sm3 class="text-md-center">
                    <p>
                      <span
                        class="subheading text-uppercase font-weight-regular"
                        style="color: #01579b"
                        >Solicitação enviada — em análise</span
                      >
                    </p>
                    <img src="@/assets/tick_green.png" height="100px" />
                  </v-flex>
                </v-layout>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-list>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "@/services/event-bus";

export default {
  name: "SelectAntecipation",
  beforeCreate() {
    EventBus.$on("anticipation.selection.modal.show", () => {
      this.dialog = true;
    });
    EventBus.$on("anticipation.selection.modal.hide", () => {
      this.dialog = false;
    });
  },
  components: {
    AnticipationsAvailable: () =>
      import("@/components/antecipation/AnticipationsAvailable.vue"),
  },
  computed: {
    ...mapGetters({
      selectedAnticipationsAmount: "user/selectedAnticipationsAmount",
      rule: "user/automaticAnticipationEnabled",
      selectedAnticipations: "user/selectedAnticipations",
      color: "account/color",
    }),
  },
  methods: {
    ...mapActions({
      updateSelectedAnticipationsAmount:
        "user/updateSelectedAnticipationsAmount",
      updateSelectedAnticipations: "user/updateSelectedAnticipations",
    }),
    disabled() {
      return true;
    },
    sleep(time) {
      return new Promise((resolve) => setTimeout(resolve, time));
    },
    sendAnticipations() {
      if (this.status === "finished") {
        this.step = 1;
        EventBus.$emit("anticipation.selection.modal.hide");
        location.reload();
      } else {
        this.status = "processing";
        this.step = 2;

        const ids = this.selectedAnticipations.map((a) => a.id);
        // Pontual anticipation now creates a request in the backoffice queue
        // instead of executing directly.
        this.$store
          .dispatch("user/requestAnticipation", {
            kind: "pontual",
            deposit_ids: ids,
            amount: this.selectedAnticipationsAmount,
          })
          .then(() => {
            this.step = 3;
            this.status = "finished";
            this.updateSelectedAnticipationsAmount(0);
            this.updateSelectedAnticipations([]);
          });
      }
    },
  },
  data() {
    return {
      status: "wait",
      dialog: false,
      step: 0,
      items: [
        { header: "Today" },
        {
          avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg",
          title: "Brunch this weekend?",
          subtitle:
            "<span class='text--primary'>Ali Connors</span> &mdash; I'll be in your neighborhood doing errands this weekend. Do you want to hang out?",
        },
        { divider: true, inset: true },
        {
          avatar: "https://cdn.vuetifyjs.com/images/lists/2.jpg",
          title: 'Summer BBQ <span class="grey--text text--lighten-1">4</span>',
          subtitle:
            "<span class='text--primary'>to Alex, Scott, Jennifer</span> &mdash; Wish I could come, but I'm out of town this weekend.",
        },
        { divider: true, inset: true },
        {
          avatar: "https://cdn.vuetifyjs.com/images/lists/3.jpg",
          title: "Oui oui",
          subtitle:
            "<span class='text--primary'>Sandra Adams</span> &mdash; Do you have Paris recommendations? Have you ever been?",
        },
      ],
    };
  },
};
</script>
